// src/pages/TermsOfUse.tsx
import React from 'react';

const TermsOfUse: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <div className="section-title">
          <h1>Terms of Use</h1>
          <p>Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        </div>

        <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using ImanVerse ("the Platform"), you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                2. Use License
              </h2>
              <p>
                Permission is granted to temporarily access the materials on ImanVerse for personal, non-commercial transitory viewing only.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                3. Islamic Content Disclaimer
              </h2>
              <p>
                The Islamic content provided on ImanVerse is for educational and spiritual purposes only. While we strive for accuracy, we recommend consulting with qualified Islamic scholars for specific religious rulings.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                4. User Conduct
              </h2>
              <p>
                Users agree not to use the Platform for any unlawful purpose or in any way that might harm, damage, or disparage any other party.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                5. Intellectual Property
              </h2>
              <p>
                All content, including but not limited to text, graphics, and logos, are the property of ImanVerse and are protected by copyright laws.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                6. Limitation of Liability
              </h2>
              <p>
                ImanVerse shall not be held liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of the Platform.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                7. Changes to Terms
              </h2>
              <p>
                ImanVerse reserves the right to modify these terms at any time. We will notify users of any changes by updating the date at the top of this page.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                8. Contact Information
              </h2>
              <p>
                For any questions about these Terms of Use, please contact us at: md.shafee05s@gmail.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;